"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("../../styles");
var useStyles = (0, styles_1.makeStyles)(function () { return ({
    container: {
        height: '100%',
        position: 'relative'
    }
}); });
exports.default = useStyles;
